import React from 'react';
import { SelectableTag } from '../selectable/index.js';
import '@magnetic/theme';
import { GroupFrame } from './group-frame.js';
import { OverflowChildren } from './overflow-children.js';
import { useSelectableOverflow } from './use-selectable-overflow.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const SelectableOverflow = /* @__PURE__ */ __name(({
  hidden,
  size
}) => {
  const { getReferenceProps, isOpen, refs, selected, ...frameProps } = useSelectableOverflow(hidden);
  return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(SelectableTag, {
    className: "mds-tag-overflow-source",
    ref: refs.setReference,
    selected,
    size,
    ...getReferenceProps()
  }, `+${hidden.length}`), isOpen && /* @__PURE__ */ React.createElement(GroupFrame, {
    getReferenceProps,
    isOpen,
    refs,
    selected,
    ...frameProps
  }, /* @__PURE__ */ React.createElement(OverflowChildren, {
    hidden
  })));
}, "SelectableOverflow");

export { SelectableOverflow };
//# sourceMappingURL=selectable-overflow.js.map
